export const parseWebsiteUrl = (websiteUrl?: string) => {
  if (!websiteUrl || /(https?:)?\/\/\w*/.test(websiteUrl)) {
    return websiteUrl;
  } else {
    return `https://${websiteUrl}`;
  }
};

export const parseDisplayUrl = (websiteUrl?: string): string | undefined => {
  if (!websiteUrl) {
    return undefined;
  }

  const cleanedUrl = websiteUrl
    .replace(/^https?:\/\//, "") // Remove http:// or https://
    .replace(/^www\./, "") // Remove www.
    .replace(/\/$/, ""); // Remove trailing slash

  return cleanedUrl || undefined;
};

export const parseInstagramHandle = (instagramHandle?: string) => {
  if (instagramHandle) {
    return `https://instagram.com/${instagramHandle}`;
  } else {
    return undefined;
  }
};

export const externalLinkRegex = new RegExp("^((?:[a-z]+:)|(//))", "i");

export const isExternalOrHashLink = (
  link: string | unknown | undefined
): link is string => {
  const isExternalLink =
    typeof link === "string" && externalLinkRegex.test(link);
  const hasHash = typeof link === "string" && link.startsWith("#");

  return isExternalLink || hasHash;
};
